import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CroudTvaComponent } from './parametre-tva/croud-tva/croud-tva.component';
import { CroudTaxeComponent } from './parametre-taxe/croud-taxe/croud-taxe.component';
import { ParametreService } from '../main-parametre/parametre.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { debounceTime, filter } from 'rxjs/operators';
import { Tva } from './parametre-tva/tva.service';
import { Taxe } from './parametre-taxe/taxe.service';

@Component({
  selector: 'app-taxe-tva',
  templateUrl: './taxe-tva.component.html',
  styleUrls: ['./taxe-tva.component.scss']
})
export class TaxeTvaComponent implements OnInit, OnDestroy, AfterViewInit {
   checkPopup: string = 'taxe';
  activeTab: 'tva' | 'taxe' = 'taxe';
  showAddButton: boolean = true;
  private subscriptions = new Subscription();
  private componentId = Math.random().toString(36).substring(2);

  @ViewChild('croudTva') croudTva?: CroudTvaComponent;
  @ViewChild('croudTaxe') croudTaxe?: CroudTaxeComponent;

  constructor(
    private parametreService: ParametreService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal
  ) {
   // console.log('TaxeTvaComponent: Constructor called, componentId:', this.componentId);
  }

ngOnInit(): void {
 // console.log('TaxeTvaComponent: ngOnInit called, componentId:', this.componentId);
  this.setupRouteSubscription();
  this.setupModalSubscription();
  this.activeTab = 'taxe';
  this.checkPopup = 'taxe';
  this.router.navigate(['/main/parametre/taxe-tva/taxe']);
  //console.log('TaxeTvaComponent: Initial activeTab:', this.activeTab, 'componentId:', this.componentId);
}

  ngAfterViewInit(): void {
    //console.log('TaxeTvaComponent: ngAfterViewInit called, componentId:', this.componentId);
    setTimeout(() => {
      if (!this.croudTva || !this.croudTaxe) {
        console.warn('TaxeTvaComponent: One or both modal components not initialized, croudTva:', this.croudTva, 'croudTaxe:', this.croudTaxe, 'componentId:', this.componentId);
      } else {
        if (this.activeTab === 'taxe' && this.croudTaxe) {
        //  console.log('TaxeTvaComponent: Taxe tab active, relying on CroudTaxe to load data');
        } else if (this.activeTab === 'tva' && this.croudTva) {
         // console.log('TaxeTvaComponent: TVA tab active, relying on CroudTva to load data');
        }
      }
    }, 0);
  }

  ngOnDestroy(): void {
   // console.log('TaxeTvaComponent: ngOnDestroy called, unsubscribing, componentId:', this.componentId);
    this.subscriptions.unsubscribe();
  }

  private setupRouteSubscription(): void {
    this.subscriptions.add(
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        debounceTime(100)
      ).subscribe(() => {
        const currentUrl = this.router.url;
       // console.log('TaxeTvaComponent: Current URL:', currentUrl, 'componentId:', this.componentId);
        this.activeTab = currentUrl.includes('/tva') ? 'tva' : 'taxe';
       // console.log('TaxeTvaComponent: Updated activeTab:', this.activeTab, 'componentId:', this.componentId);
      })
    );
  }

  private setupModalSubscription(): void {
    this.subscriptions.add(
      this.parametreService.openModal$.pipe(debounceTime(100)).subscribe(({ component, action, subType }) => {
        console.log('TaxeTvaComponent: Received openModal event:', { component, action, subType, componentId: this.componentId });
        if (component === 'taxe-tva' && action === 'add') {
          this.openModal('ajouter', undefined, undefined, subType || this.activeTab);
        }
      })
    );
  }

  check(tab: 'tva' | 'taxe'): void {
    console.log('TaxeTvaComponent: Tab switched to:', tab, 'componentId:', this.componentId);
    this.activeTab = tab;
    this.checkPopup = tab;
    this.router.navigate([`/main/parametre/taxe-tva/${tab}`], { queryParamsHandling: 'preserve' }); 
  }

  openModal(type: 'ajouter' | 'update' | 'etat' = 'ajouter', item?: Tva | Taxe, statut?: boolean, subType?: string): void {
    console.log("je suis ici ",type);
    const target = subType || this.activeTab;
    if (target === 'tva' && this.croudTva) {
      this.croudTva.openModal(type, item as Tva, statut);
    } else if (target === 'taxe' && this.croudTaxe) {
      this.croudTaxe.openModal(type, item as Taxe, statut);
    } else {
      console.error('TaxeTvaComponent: Component not available:', { target, croudTva: !!this.croudTva, croudTaxe: !!this.croudTaxe, componentId: this.componentId });
    }
  }

  addtax(): void {
    this.parametreService.triggerModal('taxe-tva', 'add', this.activeTab);
  }
}